
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93uc3XMTmGISMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/[...slug].vue?macro=true";
import { default as _404EGWmQ9dYIPMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/404.vue?macro=true";
import { default as _91_91filter_93_93AnSeHn69qbMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/account/bookings/[[filter]].vue?macro=true";
import { default as indexpgsBGjTwpBMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/account/index.vue?macro=true";
import { default as notificationsVTefony3leMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/account/notifications.vue?macro=true";
import { default as paymentsaRmOvhdTUEMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/account/payments.vue?macro=true";
import { default as personal_45infoMHSzjNpJzVMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/account/personal-info.vue?macro=true";
import { default as securityZLG9BzUfK7Meta } from "/codebuild/output/src271734474/src/gx-booking/pages/account/security.vue?macro=true";
import { default as confirm6BfSyqJWuoMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/experiences/[parentId]/[serviceId]/confirm.vue?macro=true";
import { default as indexdTuB7MnPUmMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/experiences/[parentId]/[serviceId]/index.vue?macro=true";
import { default as _91bookingId_93mzt5RA5oE5Meta } from "/codebuild/output/src271734474/src/gx-booking/pages/experiences/[parentId]/[serviceId]/return/[bookingId].vue?macro=true";
import { default as _91accessKey_93G5OZDfkhjMMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/gratuity/[accessKey].vue?macro=true";
import { default as loginG5HJJhMTKHMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/login.vue?macro=true";
import { default as _91code_9372lGhLkdYjMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/referral/[code].vue?macro=true";
import { default as reset_45passwordmJ35bhwVJhMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/reset-password.vue?macro=true";
import { default as set_45passwordYD1Qj1cbgvMeta } from "/codebuild/output/src271734474/src/gx-booking/pages/set-password.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93uc3XMTmGISMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/[...slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/404.vue")
  },
  {
    name: "account-bookings-filter",
    path: "/account/bookings/:filter?",
    meta: _91_91filter_93_93AnSeHn69qbMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/account/bookings/[[filter]].vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexpgsBGjTwpBMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/account/index.vue")
  },
  {
    name: "account-notifications",
    path: "/account/notifications",
    meta: notificationsVTefony3leMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/account/notifications.vue")
  },
  {
    name: "account-payments",
    path: "/account/payments",
    meta: paymentsaRmOvhdTUEMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/account/payments.vue")
  },
  {
    name: "account-personal-info",
    path: "/account/personal-info",
    meta: personal_45infoMHSzjNpJzVMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/account/personal-info.vue")
  },
  {
    name: "account-security",
    path: "/account/security",
    meta: securityZLG9BzUfK7Meta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/account/security.vue")
  },
  {
    name: "experiences-parentId-serviceId-confirm",
    path: "/experiences/:parentId()/:serviceId()/confirm",
    meta: confirm6BfSyqJWuoMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/experiences/[parentId]/[serviceId]/confirm.vue")
  },
  {
    name: "experiences-parentId-serviceId",
    path: "/experiences/:parentId()/:serviceId()",
    meta: indexdTuB7MnPUmMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/experiences/[parentId]/[serviceId]/index.vue")
  },
  {
    name: "experiences-parentId-serviceId-return-bookingId",
    path: "/experiences/:parentId()/:serviceId()/return/:bookingId()",
    meta: _91bookingId_93mzt5RA5oE5Meta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/experiences/[parentId]/[serviceId]/return/[bookingId].vue")
  },
  {
    name: "gratuity-accessKey",
    path: "/gratuity/:accessKey()",
    meta: _91accessKey_93G5OZDfkhjMMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/gratuity/[accessKey].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginG5HJJhMTKHMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/login.vue")
  },
  {
    name: "referral-code",
    path: "/referral/:code()",
    meta: _91code_9372lGhLkdYjMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/referral/[code].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordmJ35bhwVJhMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/reset-password.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    meta: set_45passwordYD1Qj1cbgvMeta || {},
    component: () => import("/codebuild/output/src271734474/src/gx-booking/pages/set-password.vue")
  }
]